import React from 'react';
import { Stethoscope, FlaskConical, FileText, Mail, RefreshCcw, Settings2 } from 'lucide-react';
import { included } from '../../mock';

const icons = [Stethoscope, FlaskConical, FileText, Mail, RefreshCcw, Settings2];

const Included = () => {
  return (
    <section className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 reveal">
            <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-4">What every program includes</div>
            <h2 className="font-serif text-4xl lg:text-5xl text-green tracking-tight leading-[1.04]">
              A complete care <em className="italic">experience</em>, delivered end-to-end.
            </h2>
            <p className="mt-5 text-[var(--brand-mute)] text-lg">
              Duration and frequency of consultations is individualised based on your health needs and goals. Our team works with you long-term to achieve sustainable results.
            </p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {included.map((it, i) => {
              const Ic = icons[i % icons.length];
              return (
                <div key={it.title} className="reveal card-hover rounded-2xl p-6 border border-[rgba(31,58,46,0.08)] bg-[var(--brand-cream-2)]">
                  <div className="h-11 w-11 rounded-full grid place-items-center bg-[var(--brand-green)] text-[var(--brand-cream)] mb-4">
                    <Ic size={18} strokeWidth={1.6} />
                  </div>
                  <div className="font-serif text-xl text-green leading-tight">{it.title}</div>
                  <p className="mt-2 text-sm text-[var(--brand-mute)] leading-relaxed">{it.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Included;
